import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchApplicationTypes } from './declarationSlice';
import styles from './Decloration.module.css';
import Button from '@mui/material/Button';
import Loader from '../subsidiary/Loader/Loader';

const DeclarationTypeSelection = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const types = useSelector(state => state.declarationSlice.applicationTypes);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadTypes = async () => {
            try {
                await dispatch(fetchApplicationTypes());
                setLoading(false);
            } catch (error) {
                console.error('Error loading application types:', error);
                setLoading(false);
            }
        };
        loadTypes();
    }, [dispatch]);

    const handleTypeSelect = (type) => {
        // Navigate to the declaration form with the selected type
        navigate(`/declarations/${type.id}`);
    };

    const handleBack = () => {
        navigate('/declaration');
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div className='content-wrapper'>
            <div className="page-title-container">
                <h1 className="page-title">
                    Выберите тип заявления
                </h1>
                <Button 
                    onClick={handleBack}
                    style={{
                        color: '#EF2E25',
                        border: '1px solid #EF2E25',
                        borderRadius: '20px',
                        padding: '8px 16px',
                        fontSize: '14px',
                        textTransform: 'none'
                    }}
                >
                    ← Назад
                </Button>
            </div>

            <div className={styles.declarationBody}>
                {types && types.length > 0 ? (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '20px',
                        padding: '20px 0'
                    }}>
                        {types.map((type, index) => (
                            <div
                                key={type.id || index}
                                onClick={() => handleTypeSelect(type)}
                                style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '12px',
                                    padding: '24px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                                }}
                            >
                                <h3 style={{
                                    margin: '0 0 12px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#333'
                                }}>
                                    {type.name}
                                </h3>
                                {type.description && (
                                    <p style={{
                                        margin: '0 0 16px 0',
                                        fontSize: '14px',
                                        color: '#666',
                                        lineHeight: '1.5'
                                    }}>
                                        {type.description}
                                    </p>
                                )}
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#999'
                                    }}>
                                        Нажмите для выбора
                                    </span>
                                    <div style={{
                                        width: '24px',
                                        height: '24px',
                                        borderRadius: '50%',
                                        backgroundColor: '#EF2E25',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontSize: '12px'
                                    }}>
                                        →
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{
                        textAlign: 'center',
                        padding: '40px 20px',
                        color: '#666'
                    }}>
                        <p>Типы заявлений не найдены</p>
                        <Button 
                            onClick={handleBack}
                            style={{
                                marginTop: '16px',
                                color: '#EF2E25',
                                border: '1px solid #EF2E25'
                            }}
                            variant="outlined"
                        >
                            Вернуться назад
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeclarationTypeSelection; 